import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { mixGetSourceColumnWarehouses } from "./services/mixin";

// Analysis Report Pages
import CustomerCare from './pages/AnalysisReport/CustomerCare';
import MarketingCampaigns from './pages/AnalysisReport/MarketingCampaigns';
import MarketingCampaignsDetail from './pages/AnalysisReport/MarketingCampaignsDetail';
import VIPCustomerCare from './pages/AnalysisReport/VIPCustomerCare';
import Voucher from './pages/AnalysisReport/Voucher';
import VoucherDetail from './pages/AnalysisReport/VoucherDetail';

// Customers Pages
// import CustomerDetail from './pages/Customers/CustomerDetail';
import Grouping from './pages/Customers/CustomerGroup/Component/Grouping';
import PoolingData from './pages/Customers/PoolingData';
import PoolingDataAuto from './pages/Customers/PoolingDataAuto';
import PoolingDataAutoDetail from './pages/Customers/PoolingDataAutoDetail';
import PoolingDataDetail from './pages/Customers/PoolingDataDetail';
import CustomerPoolingDataHistory from './pages/Customers/PoolingDataHistory';
import PoolingDataHistoryDetail from './pages/Customers/PoolingDataHistoryDetail';
import PoolingDataHistoryFile from './pages/Customers/PoolingDataHistoryFile';
import PoolingDataHistoryMt from './pages/Customers/PoolingDataHistoryMt';
import PoolingDataMapping from './pages/Customers/PoolingDataMapping';
import PoolingDataSetup from './pages/Customers/PoolingDataSetup';
import PoolingDataSetupUpdate from './pages/Customers/PoolingDataSetupUpdate';
import CustomerPoolingDataTemplateManagement from './pages/Customers/PoolingDataTemplateManagement';
// import PoolingDateCustomerList from './pages/Customers/PoolingDateCustomerList';
// import CustomerDetailsCleaned from './pages/CustomerDetailsCleaned';
import CustomerDetailsCleanedReview from './pages/CustomerDetailsCleanedReview';
import CustomerDetailsCleanedV2 from './pages/CustomerDetailsCleanedV2';
import PoolingDateCustomerListHistoryImport from './pages/Customers/PoolingDateCustomerListHistoryImport';
import PoolingDateCustomerListV2 from './pages/Customers/PoolingDateCustomerListV2';

import ImportData from './pages/Customers/ImportData';

// Member Card Pages

// Vehicle Management Pages
import VehicleList from './pages/VehicleManagement/VehicleList/indexV2';
// import VehicleList from './pages/VehicleManagement/VehicleList';
import VehicleTypeManagement from './pages/VehicleManagement/VehicleTypeManagement';
import VehicleVersionManagement from './pages/VehicleManagement/VehicleVersionManagement';

// Marketing Pages
import NotificationEmailCreate from './pages/Marketing/NotificationEmailCreate';
import NotificationEmailEdit from './pages/Marketing/NotificationEmailEdit';
import NotificationSMSEdit from './pages/Marketing/NotificationSMSEdit';
import NotificationTemplatesManagement from './pages/Marketing/NotificationTemplatesManagement';
import NotificationZNSCreate from './pages/Marketing/NotificationZNSCreate';
import NotificationZNSEdit from './pages/Marketing/NotificationZNSEdit';
import PreviewSentEmail from './pages/Marketing/PreviewSentEmail';
import PreviewSentEmail2 from './pages/Marketing/PreviewSentEmail2';
import VoucherCreate from './pages/Marketing/VoucherCreate';
import MarketingVoucherDetail from './pages/Marketing/VoucherDetail';
import VoucherSearch from './pages/Marketing/VoucherSearch';
import VouchersManagement from './pages/Marketing/VouchersManagement';

// Departmental Unit Pages
import DepartmentUnitAgency from './pages/DepartmentalUnit/Agency/Agency';
import Departments from './pages/DepartmentalUnit/Departments';
import IssuingUnit from './pages/DepartmentalUnit/IssuingUnit';
import Nationwide from './pages/DepartmentalUnit/NationWide';
import Province from './pages/DepartmentalUnit/Province';
import Regions from './pages/DepartmentalUnit/Regions';
import Units from './pages/DepartmentalUnit/Units';

// System Configuration Pages
import AccountRole from './pages/SystemConfiguration/AccountRole';
import CreateAccountRole from './pages/SystemConfiguration/AccountRole/CreateGroupRole/indexV2';
import EditAccountRole from './pages/SystemConfiguration/AccountRole/EditGroupRole/indexV2';
import InfoGroupRole from './pages/SystemConfiguration/AccountRole/InfoGroupRole';
import AccountsManagement from './pages/SystemConfiguration/AccountsManagement';
// Page Not Found
import axiosClient from './api/axiosClient';
import ToastGlobal from './components/ToastGlobal';
import useResetData from './hook/useResetData';
import AddCustomer from './pages/Customers/Component/AddCustomer';
// import CustomerGroup from './pages/Customers/CustomerGroup/index';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import tokenService from './services/token';

import LoadingGlobal from './components/LoadingGLobal';
import CustomerCareer from './pages/Customers/Career/CustomerCareer';
import CustomerHobby from './pages/Customers/Hobby/CustomerHobby';
import RecycleBin from './pages/Customers/RecycleBin';
import RecycleCustomerList from './pages/Customers/RecycleBin/Component/RecycleCustomerList';
import RecycleGroupCustomer from './pages/Customers/RecycleBin/Component/RecycleGroupCustomer';
import CustomerRelative from './pages/Customers/Relative';
// import Demo from './pages/Demo';
import NotificationFeesSetting_V2 from './pages/Marketing/NotificationFeesSetting/index';
import BrandManagement_V2 from './pages/VehicleManagement/BrandManagement/indexV2';
import { CarColorManagement } from './pages/VehicleManagement/CarColorManagement';
import ModelManagement from './pages/VehicleManagement/ModelManagement';
import ProductGroupManagement from './pages/VehicleManagement/ProductGroupManagement';
import ProductManagement from './pages/VehicleManagement/ProductManagement';
import VehicleCategory_V2 from './pages/VehicleManagement/VehicleCategoryManagement/indexV2';
// import DemoGrid from './pages/Demo/DemoGrid';
import PoolingDateCustomerDetailClone from './pages/CustomerInfoNewV3';
import CustomerGroupV2 from './pages/Customers/CustomerGroup/indexV2';
import PoolingDateCustomerListClone from './pages/Customers/PoolingDateCustomerListClone';
// import Test from './pages/Demo/test';
import CustomerInfoNewNotAPINhanV2 from './pages/CustomerInfoNewNotAPINhanV2';
// import ColSettingV2 from './components/MagaTable/ColSetting';
import { useDispatch, useSelector } from 'react-redux';
import { getListGroup } from "./api/groupCustomerV2/groupCustomerV2Api";
import { IDLE_TIME_DF } from './env';
import useInfoUser from './hook/useInfoUser';
import { startIdleTracking, stopIdleTracking } from './idle.service';
import ReportCustomer from './pages/AnalysisReport/ReportCustomer';
import ActivityTimeline from './pages/CustomerInfoNewV2/components/ListUpdateHistory';
import ManualDataMerging from './pages/Customers/ManualDataMerging';
import AddRank from './pages/CustomerService/MemberCard/AddRank';
import CardIssuance from './pages/CustomerService/MemberCard/CardIssuance';
import ClassList from './pages/CustomerService/MemberCard/ClassList';
import EditRank from './pages/CustomerService/MemberCard/EditRank';
import PolicyBenefits from './pages/CustomerService/PolicyBenefits';
import PolicyManagement from './pages/CustomerService/PolicyManagement';
import RankBenefits from './pages/CustomerService/RankBenefits';
import CustomerList_V2 from './pages/CustomersV2/indexV2';
import TestTableCar from './pages/Demo/CarDemo';
import TestDrag from './pages/Demo/TestDrag';
import CampaignSendsNotifications from './pages/Marketing/AnnouncementCampaign/CampaignSendsNotifications';
import CreateAnnouncementCampaign from './pages/Marketing/AnnouncementCampaign/Create';
import DetailAnnouncementCampaign from './pages/Marketing/AnnouncementCampaign/Detail';
import NotificationSMSCreate from './pages/Marketing/NotificationSMSCreate';
import InforAccount from './pages/SystemConfiguration/AccountsManagement/InforAccount';
import ActivityLog from './pages/SystemConfiguration/ActivityLog';
import { GeneralConfigurationV2 } from './pages/SystemConfiguration/GeneralConfigurationV2';
import NotificationEmailTemplate from './pages/SystemConfiguration/GeneralConfigurationV2/Components/NotificationEmailTemplate';
import Unauthorized from './pages/Unauthorized';
import ProtectedRoute from './services/ProtectedRoute';
import { selectorCategoryCarIds } from './store/slices/categoryCarSlice';
import { setGroupCustumer } from "./store/slices/groupCustumerSlice";
import { setSourceColumnWarehouse } from './store/slices/sourceColumnWarehouseSlice';
import VoucherEditV2 from './pages/Marketing/VoucherEditV2';
import ReportCustomerDetail from './pages/AnalysisReport/ReportCustomerDetail';
import DataQuality from './pages/AnalysisReport/DataQuality';
import EditPolicyManagement from './pages/CustomerService/MemberCard/EditPolicyManagement';
import AddPolicyManagement from './pages/CustomerService/MemberCard/AddPolicyManagement';
import CardIssuanceHistory from './pages/CustomerService/MemberCard/CardIssuanceHistory';
import AnalysisMarketingCampaigns from './pages/AnalysisReport/AnalysisMarketingCampaigns';
import MembershipTier from './pages/AnalysisReport/MembershipTier';
import ReportMemberCardList from './pages/AnalysisReport/MembershipTier/ReportMemberCardList';
import VoucherOverview from './pages/AnalysisReport/VoucherOverview';
import ReportCustomerCardList from './pages/AnalysisReport/ReportCustomer/ReportCustomerCardList';
import ComplaintsGrievances from './pages/AnalysisReport/ComplaintsGrievances';
import ReportComplaintDetailList from './pages/AnalysisReport/ComplaintsGrievances/ReportComplaintDetailList';
import PoolingDataSetupV2 from './pages/Customers/PoolingDataSetupV2';




const App: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { resetLoginExpired } = useResetData()
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
  const { getInfoUser } = useInfoUser()
  const { sessionTimeout } = getInfoUser()
  const token = tokenService.getToken()


  const gListGroupCustomer = async () => {
    const result = await getListGroup(
      permittedCategoryCarIds,
      undefined, undefined, undefined, undefined, undefined, 2
    )
    if (result?.status) {
      dispatch(setGroupCustumer(result?.data))
    } else {
    }
  }

  const getSourceColumnWarehouses = async () => {
    const obData = await mixGetSourceColumnWarehouses();
    dispatch(setSourceColumnWarehouse(obData))
  }

  axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if ((error.response) && error.response.status === 401) {
        resetLoginExpired()
        navigate("/login")
        return error?.response?.data;
      }
    }
  );

  useEffect(() => {
    if (token) {
      startIdleTracking(((sessionTimeout ?? IDLE_TIME_DF) * (60 * 1000)), () => {
        navigate("/login");
        resetLoginExpired();
      });
    }

    return () => {
      stopIdleTracking();
    };
  }, [sessionTimeout, token]);

  useEffect(() => {
    if (!token) {
      navigate("/login")
      resetLoginExpired()
    } else {
      gListGroupCustomer()
      getSourceColumnWarehouses()
    }
  }, [token, navigate]);

  return (
    <>
      <ToastGlobal />
      <LoadingGlobal />
      <Routes>

        <Route path="/*" element={<NotFound />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/login" element={<Login />} />
        <Route path="/demo" element={<ActivityTimeline />} />

        //#region Những trang phân quyền là phía trong này
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={null} />



        //#region Team Huế
          {/* Customer Pages */}
          <Route path="/customer/list" element={<CustomerList_V2 />} />
          <Route path="/customer/list/add" element={<AddCustomer />} />
          <Route path="/customer/list/edit" element={<CustomerInfoNewNotAPINhanV2 />} />

          <Route path="/customer/group" element={<CustomerGroupV2 />} />
          <Route path="/customer/group/grouping" element={<Grouping />} />

          <Route path="/customer/hobby" element={<CustomerHobby />} />
          <Route path="/customer/career" element={<CustomerCareer />} />
          <Route path="/customer/relative" element={<CustomerRelative />} />
          <Route path="/customer/recyclebin" element={<RecycleBin />} />
          <Route path="/customer/recyclecustomerlist" element={<RecycleCustomerList />} />
          <Route path="/customer/recyclegroupcustomer" element={<RecycleGroupCustomer />} />


          {/* Vehicle Management Pages */}
          <Route path="/vehicle-management/vehicle-list" element={<VehicleList />} /> {/*  xe */}
          <Route path="/vehicle-management/vehicle-type-management" element={<VehicleTypeManagement />} /> {/* dòng xe */}
          <Route path="/vehicle-management/vehicle-category-management" element={<VehicleCategory_V2 />} />{/* Loại xe */}
          <Route path="/vehicle-management/product-group-management" element={<ProductGroupManagement />} /> {/* nhóm sp */}
          <Route path="/vehicle-management/product-management" element={<ProductManagement />} />  {/* sp */}
          <Route path="/vehicle-management/brand-management" element={<BrandManagement_V2 />} />  {/* thuong hiệu */}
          <Route path="/vehicle-management/vehicle-model-management" element={<ModelManagement />} />  {/* mẫu xe */}
          <Route path="/vehicle-management/vehicle-version-management" element={<VehicleVersionManagement />} /> {/*  Phiên bản */}
          <Route path="/vehicle-management/vehicle-color-management" element={<CarColorManagement />} />

          {/* Departmental Unit Pages */}
          <Route path="/departmental-unit/nationwide" element={<Nationwide />} />
          <Route path="/departmental-unit/regions" element={<Regions />} />
          <Route path="/departmental-unit/units" element={<Units />} />
          <Route path="/departmental-unit/provinces" element={<Province />} />
          <Route path="/departmental-unit/agency" element={<DepartmentUnitAgency />} />
          <Route path="/departmental-unit/departments" element={<Departments />} />
          <Route path="/departmental-unit/issuing-unit" element={<IssuingUnit />} />

          {/* System Configuration Pages */}
          <Route path="/system-configuration/accounts-management" element={<AccountsManagement />} />
          <Route path="/system-configuration/accounts-information" element={<InforAccount />} />
          <Route path="/system-configuration/account-role" element={<AccountRole />} />
          <Route path="/system-configuration/account-role/add" element={<CreateAccountRole />} />
          <Route path="/system-configuration/account-role/edit" element={<EditAccountRole />} />
          <Route path="/system-configuration/account-role/access" element={<InfoGroupRole />} />
          <Route path="/system-configuration/general-configuration" element={<GeneralConfigurationV2 />} />
          <Route path="/system-configuration/activity-log" element={<ActivityLog />} />
          <Route path="/system-configuration/notification-email-template" element={<NotificationEmailTemplate />} />

          {/* Member Card Pages  chưa phân quyền*/}
          <Route path="/member-card/card-issuance" element={<CardIssuance />} />
          <Route path="/member-card/card-issuance-history" element={<CardIssuanceHistory />} />
          <Route path="/member-card/benefit" element={<RankBenefits />} />

          <Route path="/member-card/class-list" element={<ClassList />} />
          <Route path="/member-card/class-list/add" element={<AddRank />} />
          <Route path="/member-card/class-list/edit" element={<EditRank />} />
          {/* <Route path="/member-card/class-benefits" element={<ClassBenefits />} /> */}
          <Route path="/member-card/policy-management" element={< PolicyManagement />} />
          <Route path="/member-card/policy-management/add" element={<AddPolicyManagement />} />
          <Route path="/member-card/policy-management/edit" element={<EditPolicyManagement />} />
          <Route path="/member-card/policy-benefits" element={<PolicyBenefits />} />


          {/* /system-configuration/activity-log */}


          {/* Marketing Pages chưa phân quyền*/}
          <Route path="/marketing/campaign-sends-notifications" element={<CampaignSendsNotifications />} />
          <Route path="/marketing/campaign-sends-notifications/add" element={<CreateAnnouncementCampaign />} />
          <Route path="/marketing/campaign-sends-notifications/access" element={<DetailAnnouncementCampaign />} />
          <Route path="/marketing/campaign-sends-notifications/edit" element={<DetailAnnouncementCampaign />} />
          <Route path="/marketing/notification-templates-management" element={<NotificationTemplatesManagement />} />
          <Route path="/marketing/notification-templates-management/add" element={<NotificationSMSCreate />} />
          <Route path="/marketing/notification-templates-management/edit-sms" element={<NotificationSMSEdit />} />
          <Route path="/marketing/notification-templates-management/addzns" element={<NotificationZNSCreate />} />
          <Route path="/marketing/notification-templates-management/editzns" element={<NotificationZNSEdit />} />
          <Route path="/marketing/notification-templates-management/addemail" element={<NotificationEmailCreate />} />
          <Route path="/marketing/notification-templates-management/edit-email" element={<NotificationEmailEdit />} />
          <Route path="/marketing/notification-templates-management/previewemail" element={<PreviewSentEmail />} />
          <Route path="/marketing/notification-templates-management/previewemail2" element={<PreviewSentEmail2 />} />
          <Route path="/marketing/notification-fees-setting" element={<NotificationFeesSetting_V2 />} />
          <Route path="/marketing/vouchers-management" element={<VouchersManagement />} />
          <Route path="/marketing/vouchers-management/add" element={<VoucherCreate />} />
          <Route path="/marketing/vouchers-management/edit" element={<VoucherEditV2 />} />
          <Route path="/marketing/vouchers-management/access" element={<MarketingVoucherDetail />} />
          <Route path="/marketing/voucher-search" element={<VoucherSearch />} />

          <Route path="/analysis-report/customers" element={<ReportCustomer />} />
          <Route path="/analysis-report/customers-card-list" element={<ReportCustomerCardList />} />
          <Route path="/analysis-report/data-quality" element={<DataQuality />} />
          <Route path="/analysis-report/marketing-campaigns" element={<AnalysisMarketingCampaigns />} />
          <Route path="/analysis-report/customers-detail" element={<ReportCustomerDetail />} />
          {/* bản cũ */}
          <Route path="/analysis-report/vip-customer-care" element={<VIPCustomerCare />} />
          <Route path="/analysis-report/customer-care" element={<CustomerCare />} />
          <Route path="/analysis-report/voucher" element={<Voucher />} />
          <Route path="/analysis-report/voucher/:id" element={<VoucherDetail />} />
          <Route path="/analysis-report/membership-tier" element={<MembershipTier />} />
          <Route path="/analysis-report/member-card-list" element={<ReportMemberCardList />} />
          <Route path="/analysis-report/voucher-overview" element={<VoucherOverview />} />
          <Route path="/analysis-report/overview-complaints-grievances" element={<ComplaintsGrievances />} />
          <Route path="/analysis-report/complaint-detail-list" element={<ReportComplaintDetailList />} />






        //#endregion

          {/* Analysis Report Pages */}


          <Route path="/marketing-campaigns/:id" element={<MarketingCampaignsDetail />} />

          <Route path="/customer/pooling-data" element={<PoolingData />} />
          <Route path="/customer/pooling-data/merge-manually" element={<PoolingDataDetail />} />
          <Route path="/customer/pooling-data/mapping" element={<PoolingDataMapping />} />
          <Route path="/customer/pooling-data/pooling-data-auto" element={<PoolingDataAuto />} />
          <Route path="/customer/pooling-data/pooling-data-auto-detail" element={<PoolingDataAutoDetail />} />
          <Route path="/customer/pooling-data/pooling-data-setup" element={<PoolingDataSetupV2 />} />
          <Route path="/customer/pooling-data/pooling-data-setup-update" element={<PoolingDataSetupUpdate />} />
          <Route path="/customer/pooling-data/history" element={<CustomerPoolingDataHistory />} />
          <Route path="/customer/pooling-data/history/:id" element={<PoolingDataHistoryDetail />} />
          <Route path="/customer/pooling-data/history-maintenance/:id" element={<PoolingDataHistoryMt />} />

          <Route path="/customer/pooling-data/template-management" element={<CustomerPoolingDataTemplateManagement />} />
          <Route path="/customer/pooling-data/history-file-import" element={<PoolingDataHistoryFile />} />
          {/* <Route path="/customer/pooling-data/customer-list" element={<PoolingDateCustomerList />} />
        <Route path="/customer/pooling-data/customer-list/:id" element={<CustomerDetailsCleaned />} /> */}
          <Route path="/customer/pooling-data/customer-list" element={<PoolingDateCustomerListV2 />} />
          <Route path="/customer/pooling-data/customer-list/detail" element={<CustomerDetailsCleanedV2 />} />
          <Route path="/customer/pooling-data/customer-list/detail-review" element={<CustomerDetailsCleanedReview />} />
          <Route path="/customer/pooling-data/import-data" element={<ImportData />} />
          <Route path="/customer/pooling-data/customer-list/manual-data-merging" element={<ManualDataMerging />} />
          <Route path="/customer/pooling-data/history-import" element={<PoolingDateCustomerListHistoryImport />} />


          <Route path="/customer/customer-clone-list" element={<PoolingDateCustomerListClone />} />
          <Route path="/customer/customer-clone-list/:id" element={<PoolingDateCustomerDetailClone />} />



          {/* new */}
          {/* <Route path="/customer-info-new" element={<CustomerInforNew />} /> */}
          {/* <Route path="/test-chart" element={<TestChartPageV2 />} /> */}

          {/* <Route path="/customer/list/:id/vehicle" element={<CustomerVehicleInfo />} /> */}

          {/* <Route path="/customer/history-maintenanceCar" element={<InfoDataCar />} /> */}

          {/* <Route path="/customer/update-customer/:id" element={<UpdateCustomer />} />   k dùng nữa */}
          {/* <Route path="/analysis-report/marketing-campaigns" element={<MarketingCampaigns />} /> */}
        </Route>

        //#endregion


        {/* Not Found Page */}


        {/* demo */}

        <Route path="/test-car" element={<TestTableCar />} />
        <Route path="/test-drag" element={<TestDrag />} />
      </Routes>
    </>
  );
}

export default App;
